import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'

// routes config
import routes from '../routes'

const loading = (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    <CSpinner color="primary" size="sm" style={{ width: '3rem', height: '3rem' }} />
  </div>
)
const AppContent = () => {
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}')
  const currentRole = currentUser?.role || ''
  const isHouseLead = currentRole === 'house-lead'
  const isTechnicalSupport = currentRole === 'technical-support'

  const technicalSupportAllowedPaths = [
    '/messages',
    '/messages/inappropriate',
    '/users',
    '/users/:id/challenges',
    '/checkins/:id',
    '/challenges/inappropriate/responses',
  ]

  const allowedRoutes = isHouseLead
    ? routes.filter((route) => route.path === '/messages')
    : isTechnicalSupport
      ? routes.filter((route) => technicalSupportAllowedPaths.includes(route.path))
      : routes

  return (
    <CContainer lg>
      <Suspense fallback={loading}>
        <Routes>
          {allowedRoutes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
          <Route
            path="/"
            element={
              <Navigate
                to={isHouseLead ? 'messages' : isTechnicalSupport ? 'users' : 'dashboard'}
                replace
              />
            }
          />
          {(isHouseLead || isTechnicalSupport) && (
            <Route
              path="*"
              element={<Navigate to={isHouseLead ? '/messages' : '/users'} replace />}
            />
          )}
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
